export let trackReadReceipts = "sF7oy";
export default {trackReadReceipts};